export default "__VITE_ASSET__26dcc519__"